
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AlTab',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    arrow: {
      type: Boolean,
      default: false,
    },
  },
})
